import { FC, memo } from 'react'
import { Button, ButtonProps, Center, Text } from '@chakra-ui/react'

type Props = ButtonProps & {
  permissions?: string[]
  customDisableCondition?: boolean
  count?: number
}

const CountButton: FC<Props> = ({ count = 0, customDisableCondition = null, permissions, children, ...props }) => {
  return (
    <Button
      customDisableCondition={customDisableCondition}
      permissions={permissions}
      variant="outline"
      leftIcon={
        <Center bg="primary" rounded="full" p={3} width="20px" height="20px">
          <Text fontWeight="bold" color="light" fontSize="xs">
            {count}
          </Text>
        </Center>
      }
      width="max-content"
      size="md"
      {...props}
    >
      {children}
    </Button>
  )
}

export default memo(CountButton)
